/* hc-storefaq.js - script de sections/store-faq.liquid, externalise le 19-08-2026 (defer). */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.store-faq').forEach(function (faqContainer) {
    var container = faqContainer.querySelector('.faq-container');
    if (!container) return;

    var faqItems = faqContainer.querySelectorAll('.faq-item');
    var isAccordion = container.getAttribute('data-accordion') === 'true';

    faqItems.forEach(function (item) {
      var question = item.querySelector('.faq-question');
      if (!question) return;

      question.addEventListener('click', function () {
        var isActive = item.classList.contains('active');

        // Close all other items first if accordion mode is enabled
        if (isAccordion && !isActive) {
          faqItems.forEach(function (otherItem) {
            otherItem.classList.remove('active');
          });
        }

        // Toggle the clicked item
        item.classList.toggle('active');
      });
    });
  });
});